import React, { useEffect, useState } from 'react';
import Footer from '../../components/footer';
import { useDeviceType } from 'common-utilities';
import OutlinedButton from '../../components/outlineButton';
import SheildIcon from '../../assets/svg/paytmSheild.svg';
import './style.scss';
import MobileFooter from '../../components/mobileFooter';
import { SCREEN_NAME, EVENT_CATEGORY, DEFAULT_IVR, PAYTM_CARE_URL } from '../../constants';
import {
	DEVICES,
	getCurrentEnv,
	Pulse,
	NavigationHelpers,
	DeviceHelper,
	NetworkHelper,
	fetchPropertyConfig
} from 'common-utilities';

const ENV = getCurrentEnv();
const screenName = SCREEN_NAME + '_error';
function Error(props) {
	const Device = useDeviceType();
	const [fraudIVR, setfraudIVR] = useState('');
	const setConfigData = async () => {
		setfraudIVR(await fetchPropertyConfig('fraud_detection_ivr_number'));
	};
	useEffect(() => {
		setTimeout(() => {
			Pulse.push({
				event_action: 'logout_expired_screen_loaded',
				screenName,
				platform: DeviceHelper.identify(),
				event_category: EVENT_CATEGORY
			});
		});
		setConfigData();
	}, []);
	return (
		<React.Fragment>
			<div className="errorPageContainer">
				<div className="imageContainer">
					<img src={SheildIcon} alt="sheild-icon" />
				</div>
				<div className="heading">Page Expired</div>
				<div className="text-container">
					This link is no longer active. Please go to security settings in Paytm App to
					logout from all mobile devices, computers and linked apps.
				</div>
				{Device === DEVICES.DESKTOP ? (
					<div className="buttonContainer">
						<OutlinedButton
							onClick={() => {
								Pulse.push({
									event_action: 'need_help_clicked',
									screenName,
									event_category: EVENT_CATEGORY
								});
								NavigationHelpers.redirectToPaytm(PAYTM_CARE_URL);
							}}
							oauth-id="need_help_btn"
						>
							<div className="buttonText">Need Help?</div>
						</OutlinedButton>
					</div>
				) : null}
			</div>
			{Device === DEVICES.DESKTOP ? (
				<Footer />
			) : (
				<MobileFooter
					onClick={() => {
						Pulse.push({
							event_action: 'need_help_clicked',
							screenName,
							event_category: EVENT_CATEGORY
						});
						NavigationHelpers.redirectToPaytm(PAYTM_CARE_URL);
					}}
					oauth-id="need_help_btn"
				>
					Need Help?
				</MobileFooter>
			)}
		</React.Fragment>
	);
}
export default Error;
